import React from 'react'

import { Link } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import styles from './index.module.scss'

interface TipLinkBaseProps {
  text: string
}
interface TipLinkHrefProps extends TipLinkBaseProps {
  href: string
  target?: string
}
interface TipLinkButtonProps extends TipLinkBaseProps {
  onClick: () => void
}
type TipLinkProps = TipLinkHrefProps | TipLinkButtonProps

export const TipLink = (tip: TipLinkProps) => {
  if ('onClick' in tip) {
    return <Link.Touchable onClick={tip.onClick}>{tip.text}</Link.Touchable>
  }

  return (
    <a className={styles.link} href={tip.href} target={tip.target} rel="noopener noreferrer">
      {tip.text}
    </a>
  )
}

interface Props {
  tips: ReturnType<typeof i18n.tView>[]
}

export const Tips = ({ tips }: Props) => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.title}>{i18n.t('import.tips.title')}</div>
      <ul className={styles.list}>
        {tips.map((tip, idx) => (
          <li className={styles.tip} key={idx}>
            {tip}
          </li>
        ))}
      </ul>
    </div>
  )
}
